import config from '../../config'
export const ContactUs = {
	header: "NavBarDesktop.NavBarDesktopContactUs",
	name: "Biosci (Thailand) Co., Ltd",
	address:
		"131 Thailand Science Park, Innovation Cluster 1 Building, Suite no. INC1-311, 3rd Floor, Moo 9, Paholyothin Road, Klong Neung Sub-District, Klong Luang District, Pathumthani 12120",
	addresslink:
		"https://www.google.co.th/maps/place/Biosci(Thailand)Co.,Ltd/@14.076996,100.5854695,14z/data=!4m8!1m2!2m1!1sbiosci!3m4!1s0x30e2bce6dc3de613:0xddfd90c7d66afd8d!8m2!3d14.076996!4d100.602979",
	telephone: "+66 (0)2-564-7757",
	telephonelink: "tel:+6625647757",
	email: config.emailsupport,
	emaillink: `mailto:${config.emailsupport}`,
	facebook: "https://www.facebook.com/MixedModelAcademy/",
	youtube: "https://www.youtube.com/channel/UC4mgvX4RGrkYN0acfPlYLUw",
	linkedin: "https://www.linkedin.com/company/mixed-model-academy/about/",
	twitter: "https://twitter.com/MixedModelACAD"
}

export const Video = [
	{
		vidNo: "1",
		name: "Mixed Model Academy (MMA)",
		owner: "VSN International",
		embed: "BrbfCJpiLr0",
		thumbnail: "/VideoThumnails/1.jpg",
		description:
			"Mixed Model Academy (MMA) is an online library and playground for mixed model learners and practitioners to explore the power of mixed models."
	},
	{
		vidNo: "2",
		name: "Getting started in MMA",
		owner: "VSN International",
		embed: "9gPo6NJ1jRY",
		thumbnail: "/VideoThumnails/2.jpg",
		description:
			"Mixed Model Academy (MMA) is an online library and playground for mixed model learners and practitioners to explore the power of mixed models."
	},
	{
		vidNo: "3",
		name: "How to create a project in MMA",
		owner: "VSN International",
		embed: "dHiYoZEw_0Y",
		thumbnail: "/VideoThumnails/3.jpg",
		description:
			"Exploring each step of projects creating in MMA and start sharing with the Mixed Model Community"
	},
	{
		vidNo: "4",
		name: "Creating a model in MMA",
		owner: "VSN International",
		embed: "ogNbeBY-XXU",
		thumbnail: "/VideoThumnails/4.jpg",
		description:
			"Creating simple linear mixed models to applied mixed models for multiple disciplines (Agriculture, Medical, Engineering, Sciences, and etc.)"
	},
	{
		vidNo: "5",
		name: "Fitting your model in ASReml R4",
		owner: "VSN International",
		embed: "zyT3YMUQHts",
		thumbnail: "/VideoThumnails/5.jpg",
		description:
			"Learn how to fit a mixed effects model in ASReml-R 4 using code generated by MMA."
	},
	{
		vidNo: "6",
		name: "Heart rate in rats",
		owner: "VSN International",
		embed: "wfoWB7oy3q4",
		thumbnail: "/VideoThumnails/6.jpg",
		description:
			"Mixed Model Academy (MMA). The Heart Rate in Rats project contains data from a 2x2 cross-over experiment to assess the effect of two drugs on the heart rate of rats."
	},
	{
		vidNo: "7",
		name: "Foetal scan",
		owner: "VSN International",
		embed: "YA14eSYMGeo",
		thumbnail: "/VideoThumnails/7.jpg",
		description:
			"Mixed Model Academy (MMA). The Foetal Scan project contains data from an experiment to assess whether there is systematic variability in ultrasound scan measurements made by different radiologists."
	},
	{
		vidNo: "8",
		name: "Defining complex variance structures in MMA: Part 1",
		owner: "VSN International",
		embed: "gqgPz2NdGik",
		thumbnail: "/VideoThumnails/8.jpg",
		description:
			"Mixed Model Academy (MMA). In this series of tutorial videos, we’re going to learn how to specify mixed effects models with complex variance structures in MMA. In Part 1 we’ll show you how to model the correlation structure of repeated measures data."
	},
	{
		vidNo: "9",
		name: "Defining complex variance structures in MMA: Part 2",
		owner: "VSN International",
		embed: "FhUCr1dVKus",
		thumbnail: "/VideoThumnails/9.jpg",
		description:
			"Mixed Model Academy (MMA). In this series of tutorial videos we’re going to learn how to specify mixed effects models with complex variance structures in MMA. In Part 2 we’ll show you how to accommodate the correlation structure of a random coefficient regression."
	},
	{
		vidNo: "10",
		name: "Defining complex variance structures in MMA: Part 3",
		owner: "VSN International",
		embed: "3hK89Dw4nLw",
		thumbnail: "/VideoThumnails/10.jpg",
		description:
			"Mixed Model Academy (MMA). In this series of tutorial videos we’re going to learn how to specify mixed effects models with complex variance structures in MMA. In Part 3 we’ll show you how to model the correlation structure of spatial data"
	}
]
